import React from "react";
import PropTypes from "prop-types";

import { Field } from "react-final-form";

import { days, months, years } from "components/event-search/constants/dates";

const DateFilter = ({ values, label, show }) => (
  <div className={`event-date-filter${show ? " is-visible" : ""}`}>
    <div className="event-date-filter__year">
      <label className="event-date-filter__label">{label}</label>
      <Field name="year" component="select">
        {({ input }) => {
          if (values.date_ranges && values.date_ranges !== "custom") {
            input.onChange();
          }

          return (
            <select className="event-date-filter__select" {...input}>
              <option aria-label="Kies een jaar" />
              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          );
        }}
      </Field>
    </div>
    <div className="event-date-filter__month">
      <label className="event-date-filter__label">
        met de maand
        <Field name="month" component="select">
          {({ input }) => {
            if (values.date_ranges && values.date_ranges !== "custom") {
              input.onChange();
            }

            return (
              <select className="event-date-filter__select" {...input}>
                <option aria-label="Kies een maand" />
                {months.map((month) => (
                  <option key={month.label} value={month.value}>
                    {month.label}
                  </option>
                ))}
              </select>
            );
          }}
        </Field>
      </label>
    </div>
    <div className="event-date-filter__day">
      <label className="event-date-filter__label">
        en dag
        <Field name="day" component="select">
          {({ input }) => {
            if (values.date_ranges && values.date_ranges !== "custom") {
              input.onChange();
            }

            return (
              <select className="event-date-filter__select" {...input}>
                <option aria-label="Kies een dag" />
                {days.map((day) => (
                  <option key={day} value={day}>
                    {day}
                  </option>
                ))}
              </select>
            );
          }}
        </Field>
      </label>
    </div>
  </div>
);

DateFilter.defaultProps = {
  values: {},
  show: false,
};

DateFilter.propTypes = {
  values: PropTypes.shape({}),
  label: PropTypes.string.isRequired,
  show: PropTypes.bool,
};

export default DateFilter;
